import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core'
import * as WOW from 'wow.js/dist/wow'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  moveOut = false
  prevScrollY: number = 0

  ngAfterViewInit() {
    new WOW({ offset: 200 }).init();
  }

  ngOnInit() {
    if (window.innerWidth > 1000) {
      if (window.scrollY > 60) {
        this.moveOut = true
      }
      this.prevScrollY = window.scrollY
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    if (window.innerWidth <= 1000) return
    let scrollTop = window.scrollY
    if (scrollTop > 70 && this.prevScrollY < scrollTop) {
      this.moveOut = true
    } else if (scrollTop < 50 && this.prevScrollY > scrollTop) {
      this.moveOut = false
    }
    this.prevScrollY = scrollTop
  }
}
